<template>
	<div>
		<div v-if="!noResults">
			<div class="page-header page-header-small">
				<parallax v-if="imagens.length > 0" class="page-header-image"
					v-bind:style="{'background-image': 'url(' + imagens[(Math.random() * (imagens.length - 1)).toFixed()].PIm_Imagem  +')'}">
				</parallax>
				<div class="content-center">
					<div class="container">
						<h1 class="title">{{empresa.Pes_Nome}}</h1>
						<div class="text-center">
							<star-rating :config="config"></star-rating>
							<a href="#pablo" class="btn btn-blue btn-icon btn-round">
								<i class="fab fa-facebook-square"></i>
							</a>
							<a href="#pablo" class="btn btn-blue btn-icon btn-round">
								<i class="fab fa-twitter"></i>
							</a>
							<a href="#pablo" class="btn btn-blue btn-icon btn-round">
								<i class="fab fa-google-plus"></i>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="section bg-grey section-team ">
				<div class="container">
					<div class="row">
						<div class="col-md-8 ml-auto mr-auto text-center">
							<h2 class="title">Sobre</h2>
							<h4 v-if="empresa.PAJ_Apresentacao != ''" class="text-center">
								{{empresa.PAJ_Apresentacao}}
							</h4>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<div class="card h-400">
								<div class="card-body">
									<h5 class="text-info"> Horário de Funcionamento </h5>
									<ul class="list-group">
										<li v-for="horario in horarios" v-bind:key="horario.codigo" class="list-group-item">
											<strong>{{horario.Dia}}</strong>: 
											<label>{{horario.PHF_Hora1}} às {{horario.PHF_Hora2}}</label>
											<label v-if="horario.PHF_Hora3 != ''"> e {{horario.PHF_Hora3}} às {{horario.PHF_Hora4}}</label>
										</li>				
									</ul>
								</div>
							</div>

						</div>
						<div class="col-md-6">
							<div class="card h-400">
								<div class="card-body">
									<h5 class="text-info"> Informações </h5>
									<ul class="list-group">
										<li class="list-group-item"><strong>Endereço:</strong> {{empresa.Endereco}}</li>
										<li class="list-group-item"><strong>Telefone:</strong> {{empresa.PAJ_Telefone}}</li>
										<li class="list-group-item"><strong>Celular:</strong> {{empresa.PAJ_Celular}}</li>
										<li class="list-group-item"><strong>E-mail:</strong> {{empresa.PAJ_Email}}</li>
									</ul>
								</div>
							</div>
						</div>

						<div class="col-md-6">
							<div class="card h-400">
								<div class="card-body">
									<h5 class="text-info"> Formas de Pagamento </h5>
									<ul class="list-group">
										<li v-for="pagamento in pagamentos" v-bind:key="pagamento.codigo" class="list-group-item">
											{{pagamento.Descricao}}
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<div class="card h-400">
								<h4 class="text-center" v-if="!hasLatLong">Sem informações de Localização</h4>
								<gmap-map v-if="hasLatLong" :center="center" :zoom="16" style="width:100%;height: 100%;">
									<gmap-marker :position="center"></gmap-marker>
								</gmap-map>							
							</div>
						</div>
					</div>
				</div>

			</div>

			
			<div class="section bg-white text-center">
				<div class="container">
					<h2 class="title">Profissionais</h2>
					<div class="team">
						<div class="row">
							<div class="col-md-4" v-for="profissional in profissionais" v-bind:key="profissional.codigo">
								<div class="team-player">
									<img v-if="profissional.PAF_Imagem != ''" v-bind:src="profissional.PAF_Imagem"
										class="rounded-circle square-300" />
									<img v-if="profissional.PAF_Imagem == ''" src="https://sites.appbarber.com.br/02.jpg"
										class="rounded-circle square-300" />
									<h4 class="title">{{profissional.Pes_Nome}}</h4>
									
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="section bg-grey section-team text-center">
				<div class="container">
					<h2 class="title">Serviços</h2>
					<div class="team">
						<div class="row">
							<div class="col-md-4" v-for="(servico) in servicos" v-bind:key="servico.codigo">
								<card class="min-h-500">
									<img slot="image" class="card-img-top h-300" v-if="servico.Ser_Figura != ''" 
										v-bind:src="servico.Ser_Figura">
									<img slot="image" class="card-img-top h-300" v-if="servico.Ser_Figura == ''"
										src="https://s3-sa-east-1.amazonaws.com/img-appbarber-appbeleza/salaodoalemaum/5dcdad2e9b318.png">
									<div>
										<h4 class="card-title">{{servico.Ser_Descricao}}</h4>
										<p class="category text-primary">{{servico.Ser_Valor}}</p>
										
										<collapse v-if="servico.Ser_Observacao != ''">
											<collapse-item title="Descrição" name="1">
												<div  >
													{{servico.Ser_Observacao}}
												</div>
											</collapse-item>
										</collapse>
									</div>
								</card>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="section section-contact-us ">
				<div class="container">
					<h2 class="title text-center">AVALIAÇÕES</h2>
					
					<div class="row">
						<div  class=" ml-auto mr-auto col-md-8">
							<vs-list>
								<vs-list-item  v-for="avaliacao in avaliacoes" v-bind:key="avaliacao.codigo" v-bind:title="avaliacao.Nome" v-bind:subtitle="avaliacao.Comentario">
									<template  slot="avatar">
										<vs-avatar v-if="avaliacao.Imagem == ''" size="large" src="https://sistema.appbarber.com.br/img/nopicture.png"/>
										<vs-avatar v-if="avaliacao.Imagem != ''" size="large" v-bind:src="avaliacao.Imagem"/>
									</template>
									<vs-chip color="primary">
										{{avaliacao.Nota}} ⭐
									</vs-chip>
								</vs-list-item>
							</vs-list>
						</div>
					</div>
						
								<!-- <div class="pull-left">
									<img v-if="avaliacao.Imagem == ''" alt="" width="50" height="50" class="rounded-circle" data-src="https://sistema.appbarber.com.br/img/nopicture.png" src="https://sistema.appbarber.com.br/img/nopicture.png" lazy="loaded">
									<img v-if="avaliacao.Imagem != ''" alt="" width="50" height="50" class="rounded-circle" v-bind:data-src="avaliacao.Imagem" v-bind:src="avaliacao.Imagem" lazy="loaded">
									
								</div>
								{{avaliacao.Nome}}
								{{avaliacao.Nota}}
								
								<p class="comment-text">{{avaliacao.Comentario}}</p>		
								<br><hr> -->
						<!-- </div> -->
					<!-- </div> -->
				</div>
			</div>
		</div>
		<div v-if="noResults">
			<div class="section section-noresults">
				<div class="container">
					<div class="row">
						
						<div class="col-md-12">
							
							<h4 class="text-center">Sem Resultado</h4>
							<p><a href="/" class="btn btn-round btn-primary"><i class="fa fa-arrow-left"></i> Voltar</a></p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		Button,
		Card,
		FormGroupInput,
		Collapse, 
		CollapseItem
	} from '@/components';

	var StarRating = require('vue-dynamic-star-rating');

	export default {
		name: 'credenciado',
		bodyClass: 'landing-page',
		components: {
			Card,
			StarRating,
			[Button.name]: Button,
			[FormGroupInput.name]: FormGroupInput,
			Collapse,
    		CollapseItem
		},
		data() {
			return {
				config: {
					rating: 2,
					style: {
						fullStarColor: '#c12b4e',
						emptyStarColor: '#737373',
						starWidth: 10,
						starHeight: 20
					}
				},				
				center: {},
				hasLatLong: false,
				profissionais: [],
				servicos: [],
				empresa: [],
				horarios: [],
				pagamentos: [],
				comentarios: [],
				imagens: [],
				avaliacoes: [],
				social: [],
				noResults: false				
			};
		},
		methods: {
			buscaInfoEmpresa(empresa) {
				if (empresa.length > 0 && empresa[0].pescodigo !== "") {
					let codigo = empresa[0].pescodigo;
					fetch('https://ws.appbeleza.com.br/Service.php?metodo=buscaApresentacao&tipo=1&pescodigo=' + codigo)
						.then(result => result.json())
						.then(empresa => this.infoEmpresa(empresa.result));
					fetch('https://ws.appbeleza.com.br/Service.php?metodo=buscaApresentacao&tipo=4&pescodigo=' + codigo)
						.then(result => result.json())
						.then(empresa => this.infoServicos(empresa.result));
					fetch('https://ws.appbeleza.com.br/Service.php?metodo=buscaApresentacao&tipo=5&pescodigo=' + codigo)
						.then(result => result.json())
						.then(empresa => this.infoProfissionais(empresa.result));
					fetch('https://ws.appbeleza.com.br/Service.php?metodo=buscaApresentacao&tipo=2&pescodigo=' + codigo)
						.then(result => result.json())
						.then(empresa => this.infoPagamentos(empresa.result));
					fetch('https://ws.appbeleza.com.br/Service.php?metodo=buscaApresentacao&tipo=3&pescodigo=' + codigo)
						.then(result => result.json())
						.then(empresa => this.infoHorarios(empresa.result));
					fetch('https://ws.appbeleza.com.br/Service.php?metodo=buscaPessoaImagem&tipo=3&pescodigo=' + codigo)
						.then(result => result.json())
						.then(empresa => this.infoImagens(empresa.result));
					fetch('https://ws.appbeleza.com.br/Service.php?metodo=buscaPessoaAvaliacao&pages=1&tipo=1&empresa=' + codigo)
						.then(result => result.json())
						.then(empresa => this.infoAvaliacao(empresa.result));	
					fetch('https://ws.appbeleza.com.br/Service.php?metodo=buscaPessoaAvaliacao&tipo=6&empresa=' + codigo)
						.then(result => result.json())
						.then(empresa => this.infoRating(empresa.result));	
				} else {
					this.noResults = true;
				}
			},
			infoEmpresa(dados) {
				if (dados.length > 0) {
					this.empresa = dados[0];
					if (dados[0].PAJ_Latitude != ""){
						
						this.center = {
							lat: parseFloat(dados[0].PAJ_Latitude),
							lng: parseFloat(dados[0].PAJ_Longitude)
						}
						this.hasLatLong = true;
					} else {
						this.hasLatLong = false;
					}
				}
			},
			infoHorarios(dados) {
				if (dados.length > 0) {
					this.horarios = dados;
				}
			},
			infoServicos(dados) {
				this.servicos = dados;
			},
			infoProfissionais(dados) {
				this.profissionais = dados;
			},
			infoSocial(dados) {
				this.social = dados;
			},
			infoPagamentos(dados) {
				this.pagamentos = dados;
			},
			infoImagens(dados) {
				this.imagens = dados;
			},
			infoAvaliacao(dados) {
				console.log("infoAvaliacao",dados);
				this.avaliacoes = dados;
			},
			infoRating(dados){
				
				if (dados.length > 0){
					// this.config.rating = parseFloat(dados[0].Media);
					console.log("infoRating");
					console.log("infoRating",this.config.rating);
				}
				
			},
			geolocate: function() {}
		},
		beforeCreate() {
			
			fetch('https://ws.appbeleza.com.br/Service.php?metodo=buscaAbreviatura&abreviatura=' + this.$route.params.id)
				.then(result => result.json())
				.then(empresa => this.buscaInfoEmpresa(empresa.result));
		}
	};
</script>
<style>
	.square-100 {
		height: 100px !important;
		width: 100px !important;
	}

	.square-300 {
		height: 200px !important;
		width: 200px !important;
	}

	.h-300 {
		height: 20rem !important;
	}

	.h-400 {
		height: 420px !important;
		overflow-y: auto !important;
	}
	.min-h-500 {
		min-height: 520px !important;
	}

	.h-400::-webkit-scrollbar {
		width: 3px !important;
		background-color: #e2e2e2;
	}

	.h-400::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
		border-radius: 10px;
	}

	.h-400::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
		background-color: #40aaf0;
	}

	.bg-grey {
		background-color: #eeeeee !important;
	}

	.bg-white {
		background-color: white !important;
	}

	.section {
		min-height: 600px;
	}

	.section-noresults {
		text-align: center;
		height: 89.6vh;
		width: 100vw;
	}

	.mtop-50 {
		margin-top: 50px;
	}
	
	.comment-text {
		font-size: 14px;
	}
</style>
